export const toRows = (payload: unknown): any[] => {
  if (Array.isArray(payload)) return payload;
  const content = (payload as { content?: unknown } | null)?.content;
  return Array.isArray(content) ? content : [];
};
